// Detects the connected API's naked-vs-real-UTC-Z date contract (naked always means
// Europe/Vilnius) and caches it per session rather than guessing from the UI's own version -
// one UI build serves customers on different, independently-upgraded API versions.
//
// TODO(old-api-support): delete this file once every deployed API sends real UTC-Z dates (no
// naked contract left in the fleet).

import { HAS_TZ_INFO } from 'utils/DateTimeResolver';

const ISO_DATETIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

let cachedContract = null; // 'utc' | 'naked' | null (not yet observed this session)

const findFirstDateString = (data, depth = 0) => {
  if (depth > 4 || data == null) return null;
  if (typeof data === 'string') return ISO_DATETIME.test(data) ? data : null;
  if (Array.isArray(data)) {
    for (const item of data) {
      const found = findFirstDateString(item, depth + 1);
      if (found) return found;
    }
    return null;
  }
  if (typeof data === 'object') {
    for (const key of Object.keys(data)) {
      const found = findFirstDateString(data[key], depth + 1);
      if (found) return found;
    }
  }
  return null;
};

// Scans only until the contract is known for the first time this tenant session - a later
// response is never re-validated, since the connected deployment's contract can't change without
// a tenant switch (see resetWireFormatCache, called whenever the tenant/API deployment might change).
const observeWireFormat = (responseData) => {
  if (cachedContract) return;
  const found = findFirstDateString(responseData);
  if (found) {
    cachedContract = HAS_TZ_INFO.test(found) ? 'utc' : 'naked';
  }
};

// Defaults to false (real UTC-Z) until a naked response is actually observed.
const isLegacyNakedContract = () => cachedContract === 'naked';

const resetWireFormatCache = () => {
  cachedContract = null;
};

export { observeWireFormat, isLegacyNakedContract, resetWireFormatCache };
